const BASE_URL = 'https://nodudunden.com';
export const OG_IMAGE_URL = `${BASE_URL}/og-image.png`;

export interface PageMeta {
  title: string;
  description: string;
  ogUrl: string;
}

export const PAGE_META_MAP: Record<string, PageMeta> = {
  '/': {
    title: '노후든든 — 한국인을 위한 은퇴 준비 계산기 모음',
    description:
      '복리 시뮬레이터, 국민연금 계산기, 노후 자금 계산기, FIRE 계산기 등 은퇴 준비에 필요한 모든 계산기를 무료로 제공합니다.',
    ogUrl: `${BASE_URL}/`,
  },
  '/compound': {
    title: '복리 시뮬레이터 — 투자 기간별 자산 성장 계산 | 노후든든',
    description:
      '초기 투자금, 월 납입액, 연 수익률을 입력해 복리 효과를 연도별로 확인하세요. 수익이 원금을 넘어서는 전환점을 직접 시뮬레이션합니다.',
    ogUrl: `${BASE_URL}/compound`,
  },
  '/dividend': {
    title: '배당 ETF 계산기 — 배당 재투자 복리 시뮬레이션 | 노후든든',
    description:
      '배당수익률과 재투자 여부를 설정해 장기 배당 자산의 성장을 시뮬레이션합니다. 배당 소득으로 생활비를 충당할 수 있는 시점을 확인하세요.',
    ogUrl: `${BASE_URL}/dividend`,
  },
  '/pension': {
    title: '국민연금 계산기 — 예상 수령액 및 수령 나이 계산 | 노후든든',
    description:
      '소득과 가입 기간을 입력해 국민연금 예상 수령액을 계산합니다. 조기 수령과 연기 수령 비교도 가능합니다.',
    ogUrl: `${BASE_URL}/pension`,
  },
  '/retirement': {
    title: '노후 자금 계산기 — 은퇴 후 자산 소진 나이 시뮬레이션 | 노후든든',
    description:
      '은퇴 자산으로 몇 살까지 생활할 수 있는지 계산하세요. 월 생활비와 수익률 입력만으로 자산 소진 시점과 영구 보존 가능 여부를 즉시 확인합니다.',
    ogUrl: `${BASE_URL}/retirement`,
  },
  '/retirement/goal': {
    title: '목표 설계 계산기 — 은퇴 목표 자산 달성을 위한 월 저축액 역산 | 노후든든',
    description:
      '은퇴 목표 자산을 설정하고 현재 자산과 기대 수익률을 입력하면 필요한 월 저축액을 자동으로 역산합니다.',
    ogUrl: `${BASE_URL}/retirement/goal`,
  },
  '/tax-benefit': {
    title: 'ISA·IRP 세제혜택 계산기 — 연말정산 세액공제 절세 계산 | 노후든든',
    description:
      'ISA와 IRP 납입액에 따른 세액공제 금액과 실효 수익률을 계산합니다. 연말정산 환급액을 미리 확인하세요.',
    ogUrl: `${BASE_URL}/tax-benefit`,
  },
  '/inflation': {
    title: '물가 상승 계산기 — 미래 화폐 가치 및 실질 자산 계산 | 노후든든',
    description:
      '물가 상승률을 반영해 현재 자산의 미래 구매력을 계산합니다. 노후 생활비가 몇 년 후 얼마가 될지 확인하세요.',
    ogUrl: `${BASE_URL}/inflation`,
  },
  '/checklist': {
    title: '은퇴 준비 체크리스트 — 나의 노후 준비 상태 점검 | 노후든든',
    description:
      '자산, 연금, 보험, 생활 설계 등 4개 영역에서 은퇴 준비 상태를 점검합니다. 부족한 부분을 파악하고 다음 단계를 확인하세요.',
    ogUrl: `${BASE_URL}/checklist`,
  },
  '/guide': {
    title: '안전 투자 가이드 — 나이별 포트폴리오 배분 전략 | 노후든든',
    description:
      '나이와 리스크 성향에 따른 최적 포트폴리오 배분을 안내합니다. ETF 추천과 절세 계좌 활용법까지 포함된 실전 가이드입니다.',
    ogUrl: `${BASE_URL}/guide`,
  },
  '/guide/30s': {
    title: '30대 노후 준비 가이드 — 지금 시작해야 하는 이유 | 노후든든',
    description:
      '30대 노후 준비는 큰돈보다 습관이 먼저입니다. 복리 효과가 가장 강력하게 작동하는 지금, 월 30만 원으로도 은퇴 자산을 만들 수 있습니다.',
    ogUrl: `${BASE_URL}/guide/30s`,
  },
  '/guide/40s': {
    title: '40대 노후 준비 가이드 — 지금 점검하고 가속해야 할 때 | 노후든든',
    description:
      '40대 노후 준비는 지금 얼마나 쌓았는지 점검하고, 부족한 부분을 구체적인 숫자로 채우는 시간입니다. 막연한 불안을 계획으로 바꾸세요.',
    ogUrl: `${BASE_URL}/guide/40s`,
  },
  '/guide/50s': {
    title: '50대 노후 준비 가이드 — 은퇴 10년 전 마지막 점검 | 노후든든',
    description:
      '50대 노후 준비는 더 이상 추상적인 이야기가 아닙니다. 은퇴까지 10년 이하, 지금 내 자산이 실제로 충분한지 계산하고 마지막 조정을 시작하세요.',
    ogUrl: `${BASE_URL}/guide/50s`,
  },
  '/severance': {
    title: '퇴직금 계산기 — 퇴직금 예상액 및 세금 계산 | 노후든든',
    description:
      '재직 기간과 평균 임금을 입력해 퇴직금 예상액과 퇴직소득세를 계산합니다. IRP 이전 시 절세 효과도 확인하세요.',
    ogUrl: `${BASE_URL}/severance`,
  },
  '/fire': {
    title: 'FIRE 계산기 — 조기 은퇴 목표 자산 및 달성 기간 계산 | 노후든든',
    description:
      '월 생활비와 투자 수익률을 입력해 FIRE에 필요한 목표 자산과 달성 기간을 계산합니다.',
    ogUrl: `${BASE_URL}/fire`,
  },
};

export function usePageMeta(path: string): PageMeta {
  return PAGE_META_MAP[path] ?? PAGE_META_MAP['/'];
}
